/**
 * Driver-location API – customer-facing subset. Mirrors
 * vin-pulse-os-web/src/services/driverLocationsApi.ts.
 *
 * Backend: GET /api/v1/driver-locations/live. For the Customer role this is
 * scoped server-side (getLiveLocationsForCustomer) to just the driver(s)
 * currently out on one of the caller's own active delivery stops — not the
 * full fleet map (routes/driverLocations.ts).
 */

import { apiClient } from './apiClient';

export interface DriverLocation {
  id: number;
  driver_id: number;
  driver_name: string | null;
  delivery_route_id: number | null;
  route_name: string | null;
  latitude: number;
  longitude: number;
  accuracy_meters: number | null;
  heading_degrees: number | null;
  speed_kmh: number | null;
  captured_at: string;
}

function unwrapList<T>(raw: any): T[] {
  if (Array.isArray(raw)) return raw as T[];
  if (Array.isArray(raw?.data)) return raw.data as T[];
  return [];
}

export async function getLiveLocations(): Promise<DriverLocation[]> {
  const raw = await apiClient.get<any>('/driver-locations/live');
  return unwrapList<DriverLocation>(raw);
}
